<template>
  <div class="login">
    <div class="del" @click="tologin(false)">
      <i class="el-icon-close"></i>
    </div>
    <!--    <p class="desc">06.21前注册送一天试用会员</p>-->
    <div class="login_left">
      <img
        style="margin-left: -4px; margin-top: -4px; margin-bottom: -6px"
        src="@/assets/img/login/login (5).png"
        alt=""
      />
    </div>
    <div class="login_right">
      <div class="form">
        <!--        <div class="logo flex">-->
        <!--          <img style="width: 240px" src="@/assets/img/logo.png" alt="" />-->
        <!--        </div>-->
        <el-form ref="form" :model="model">
          <el-form-item>
            <el-tabs v-model="tableState" class="el-tabs">
              <el-tab-pane label="扫码登录" name="0">
                <div class="qr-code-container">
                  <img :src="qrImageUrl" alt="扫码登录" class="qr-code-img" />
                  <div v-show="isExpired" class="overlay">
                    <div
                      @click="refreshQRCode"
                      style="
                        display: flex;
                        flex-direction: row;
                        cursor: pointer;
                      "
                    >
                      <img
                        src="@/assets/img/refreshCode.png"
                        alt=""
                        style="width: 25px; height: 25px; margin-top: 5px"
                      />
                      <div style="font-size: 18px; margin-left: 5px">
                        重新获取
                      </div>
                    </div>
                    <!--                    <p>二维码已过期</p>-->
                    <!--                    <el-button type="primary" @click="refreshQRCode">重新获取</el-button>-->
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="密码登录" name="1">
                <el-input
                  type="number"
                  v-model="model.mobile"
                  placeholder="请输入手机号码"
                >
                </el-input>
                <el-input
                  type="password"
                  v-model="model.passWord"
                  placeholder="请输入密码"
                  show-password
                  style="margin-top: 15px"
                >
                </el-input>
                <el-form-item>
                  <el-button
                    type="primary"
                    class="button"
                    @click="submit"
                    :loading="loginBtn"
                    >登录</el-button
                  >
                </el-form-item>
                <el-form-item>
                  <div class="checkbox">
                    <el-checkbox v-model="checkbox"></el-checkbox>
                    <p>
                      我已阅读并接受<b @click="toAgreement" class="agreement"
                        >《用户协议》</b
                      >
                    </p>
                  </div>
                </el-form-item>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { syssms } from "@/api/login";
import { loginQrCode } from "@/api/api";
import { getEncryptedString, encryption } from "@/utils/aesEncrypt";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import Vue from "vue";
export default {
  inject: ["reload"],
  data() {
    return {
      model: {
        mobile: "",
        passWord: "",
        captcha: "",
      },
      smstext: "获取验证码",
      smsstate: false,
      loginBtn: false,
      checkbox: false,
      tableState: "0",
      qrImageUrl: "",
      websock: null,
      uuid: "",
      expireTimestamp: 0, // 二维码过期时间戳
      isExpired: false, // 用于判断二维码是否过期
    };
  },
  created() {
    if (
      localStorage.getItem("smstext") &&
      localStorage.getItem("smstext") > 0
    ) {
      this.smstext = `${localStorage.getItem("smstext")}秒后重新发送`;
      this.smsstate = true;
      this.countdownfun(localStorage.getItem("smstext"));
    }
    this.initWebSocket();
  },
  destroyed() {
    this.websock.close();
  },
  mounted() {
    this.getQrCode();
  },
  methods: {
    getQrCode() {
      loginQrCode().then((res) => {
        if (res.success) {
          // 假设后端返回的是包含字节数组的字符串
          console.log(res);
          this.uuid = res.result.uuid;
          let base64String = res.result.url;
          // 将Base64编码的字符串转换为字节数组
          let binaryString = window.atob(base64String);
          let bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          // 将字节数组转换为Base64编码的字符串
          let base64Image = btoa(String.fromCharCode.apply(null, bytes));
          this.qrImageUrl = "data:image/png;base64," + base64Image;
          this.expireTimestamp = Date.now() + 60 * 1000; // 1分钟后过期
          this.checkQRCodeExpiration();
        }
      });
    },
    checkQRCodeExpiration() {
      // 每隔一段时间检查二维码是否过期
      setInterval(() => {
        if (Date.now() > this.expireTimestamp) {
          this.isExpired = true;
        }
      }, 1000); // 每秒检查一次
    },

    refreshQRCode() {
      this.isExpired = false; // 重置过期状态
      this.initWebSocket();
      // 重新从后端获取二维码
      this.getQrCode();
    },
    initWebSocket() {
      //初始化weosocket

      let timestamp = new Date().getTime().toString();
      let encryptedString = getEncryptedString();
      let password = encryption(
        timestamp,
        encryptedString.key,
        encryptedString.iv
      );
      const wsuri =
        "wss://www.yuanmenggaokao.com/gaokao/websocket/" + timestamp;
      this.websock = new WebSocket(wsuri, [timestamp]);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      // this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      let actions = { test: "12345" };
      this.websocketsend(JSON.stringify(actions));
    },
    // websocketonerror(){//连接建立失败重连
    //   this.initWebSocket();
    // },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);
      console.log(redata);
      let token = redata.token;
      let allDictItems = redata.sysAllDictItems;
      let userInfo = redata.userInfo;
      let uuid = redata.uuid;
      if (uuid === this.uuid) {
        this.$store.commit("setuserinfo", userInfo);
        this.$store.commit("settoken", token);
        this.$store.commit("setdictionary", allDictItems);
        this.$store.commit("setloginstate", false);
        if (userInfo.examType === "1" || userInfo.examType === "4") {
          this.$store.commit("setScore", userInfo.score);
          this.$store.commit("setPrecedence", userInfo.rank);
        } else if (userInfo.examType === "2") {
          this.$store.commit("setScore", userInfo.auditionTotalScore);
          this.$store.commit("setPrecedence", userInfo.auditionTotalRank);
        } else if (userInfo.examType === "3") {
          this.$store.commit("setScore", userInfo.peTotalScore);
          this.$store.commit("setPrecedence", userInfo.peTotalRank);
        }
        Vue.ls.set("token", token, 1000 * 60 * 60 * 24 * 30);
        if (userInfo.score == null || userInfo.selectedSubjectValue == null) {
          this.$store.commit("setuserstate", true);
        }
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    },

    tologin(state) {
      this.$store.commit("setloginstate", state);
    },
    getsms() {
      let phone =
        /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/;
      if (this.model.mobile == "") {
        this.$message.error("请输入手机号");
        return false;
      }
      if (!phone.test(this.model.mobile)) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      syssms({ mobile: this.model.mobile, passWord: this.model.passWord }).then(
        (res) => {
          // console.log(res);
          if (res.success) {
            this.$message.success("登录成功");
            this.countdownfun(60);
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    countdownfun(num) {
      let smstext = num;
      let time = setInterval(() => {
        if (smstext == 0) {
          clearInterval(time);
          this.smstext = `获取验证码`;
          this.smsstate = false;
        } else {
          smstext--;
          this.smstext = `${smstext}秒后重新发送`;
          this.smsstate = true;
          localStorage.setItem("smstext", smstext);
        }
      }, 1000);
    },
    submit() {
      let phone =
        /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/;
      if (this.model.mobile == "") {
        this.$message.error("请输入手机号");
        return false;
      }
      if (!phone.test(this.model.mobile)) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      if (this.model.passWord == "") {
        this.$message.error("请输入密码");
        return false;
      }
      if (!this.checkbox) {
        this.$message.error("请阅读并勾选用户协议、隐私协议");
        return false;
      }
      if (localStorage.getItem("promotion")) {
        this.model = {
          ...this.model,
          ...JSON.parse(localStorage.getItem("promotion")),
        };
      }
      //console.log(this.model);
      this.loginBtn = true;
      this.$store.dispatch("Login", this.model).then((res) => {
        if (res.success) {
          console.log(res);
          this.$message.success(res.message);
          this.$store.dispatch("selectUserInfo");
          this.$emit("getselective");
          //如果地址栏中带推广信息注册的时候带上推广信息
          if (localStorage.getItem("promotion")) {
            localStorage.removeItem("promotion");
          }
          this.$router.push({ query: {} });
          setTimeout(() => {
            this.reload();
          }, 1000);
        } else {
          this.$message.error(res.message || res);
        }
        this.loginBtn = false;
      });
    },
    // 用户协议
    toAgreement() {
      window.open(
        "https://aide-gaokao.oss-cn-hangzhou.aliyuncs.com/temp/%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.pdf"
      );
      // let routeUrl = this.$router.resolve({
      //   path: '/userAgreement/userAgreement',
      // });
      // window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .desc {
    position: absolute;
    bottom: 10px;
    right: 10px;
    color: #999;
  }
  .del {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
    z-index: 9;
  }
  img {
    display: block;
  }
  .login_left {
    padding: -3px;
  }
  .login_right {
    width: 460px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .form {
      /deep/.el-form {
        height: 325px;
      }
      width: 340px;
      .el-tabs {
        /deep/.el-tabs__item.is-top {
          font-size: 18px;
          font-weight: bold;
        }
        /deep/.el-tabs__item.is-active {
          color: #660874;
        }
        /deep/.el-tabs__active-bar {
          background-color: purple;
        }
      }
      .logo {
        justify-content: center;
        margin-bottom: 25px;
      }
      .posr {
        position: relative;
        .captcha {
          position: absolute;
          right: 10px;
        }
      }
      .checkbox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        p {
          color: #999999;
          margin-left: 10px;
          b {
            color: #660874;
          }
        }
      }
      .button {
        margin-top: 20px;
        width: 100%;
        height: 44px;
        background: #660874;
        border-radius: 8px;
        color: #fff;
        border: 0;
        font-weight: 700;
        font-size: 20px;
        cursor: pointer;
      }
      .agreement {
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
.qr-code-container {
  position: relative;
  margin-left: 40px;
  width: 250px;
  height: 250px;
}
.qr-code-img {
  width: 100%;
  height: 100%;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 你可以根据需要调整蒙层的样式 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
}
.qr-code-expired {
  margin-left: 40px;
  text-align: center;
  margin-top: 20px; /* 根据需要调整与过期提示的距离 */
}
</style>
